// Edit Account Name
export const EDIT_ACCOUNT_NAME_REQUEST = 'EDIT_ACCOUNT_NAME_REQUEST';
export const EDIT_ACCOUNT_NAME_DONE = 'EDIT_ACCOUNT_NAME_DONE';
export const EDIT_ACCOUNT_NAME_FAILED = 'EDIT_ACCOUNT_NAME_FAILED';